import { Issue } from "generated-graphql/graphql";

/**
 * Groups per-document compliance issues by the document id they belong to
 * (`modelId`). Used to flag a document's row in the grid's "Issues" column.
 */
export function buildIssuesByDocumentId<T extends Pick<Issue, "modelId">>(
  issues: T[]
): Map<string, T[]> {
  const byId = new Map<string, T[]>();
  for (const issue of issues) {
    if (!issue.modelId) continue;
    const existing = byId.get(issue.modelId) ?? [];
    existing.push(issue);
    byId.set(issue.modelId, existing);
  }
  return byId;
}
